import React, { PureComponent } from 'react'
import { observer } from 'mobx-react'
import i18n from 'i18next'
import moment from 'moment'

import ScheduleStatusLabel from './ScheduleStatusLabel'
import Modal from '../../../UniformComponents/Modal'
import ModalFooter from '../../../UniformComponents/ModalFooter'
import Input from '../../form/Input'
import Select from '../../form/Select'
import Button from '../../../UniformComponents/Button'
import Checkbox from '../../form/Checkbox'
import CKeditor5 from '../../CKeditor5'
import Typography from '../../../UniformComponents/Typography'

import './emailBuilder.scss'

@observer
class CreateEmailModal extends PureComponent {
    render() {
        const { distributeStore, store } = this.props
        const { scheduleStatus } = distributeStore
        const showScheduleButtons = !['cancelled', 'complete'].includes(scheduleStatus)

        return (
            <Modal
                show={distributeStore.createEmailModalVisible}
                onClose={distributeStore.closeCreateEmailModal}
            >
                <h2>{i18n.t('distributionEmailBuilder.create')}</h2>

                <div className="email-builder-modal-content">
                    {/* <InfoAccordion title="Instruction text" show>
                        CONTENT
                    </InfoAccordion> */}
                    {!['', null].includes(distributeStore.scheduleStatus)
                        && (
                            <div className="email-builder-modal-edit-content">
                                <h3>{distributeStore.emailSubject}</h3>

                                <div className="email-builder-modal-edit-status">
                                    <ScheduleStatusLabel status={distributeStore.scheduleStatus} />

                                    <div>{`Date: ${moment(distributeStore.emailSendDateTime).format('Do MMM YYYY')}`}</div>

                                    <div>{`Time: ${moment(distributeStore.emailSendDateTime).tz(store.timeZone).format('HH:mm z')}`}</div>
                                </div>

                                {showScheduleButtons
                                    && (
                                        <div className="email-builder-modal-edit-button-row">
                                            {distributeStore.scheduleStatus === 'paused'
                                                && (
                                                    <Button cssClass="regular primary email-builder-modal-edit-button" onClick={distributeStore.cancelSending}>
                                                        <i className="fal fa-circle-xmark" />

                                                        {i18n.t('distributionEmailBuilderModal.cancelSend')}
                                                    </Button>
                                                )}

                                            <Button cssClass="regular primary email-builder-modal-edit-button" onClick={distributeStore.goToScheduleModal}>
                                                <i className="fal fa-edit" />

                                                {i18n.t('distributionEmailBuilderModal.editSchedule')}
                                            </Button>

                                            {distributeStore.scheduleStatus === 'paused'
                                                && (
                                                    <Button cssClass="regular primary email-builder-modal-edit-button" onClick={distributeStore.resumeSending}>
                                                        <i className="fa fa-circle-play" />

                                                        {i18n.t('distributionEmailBuilderModal.resumeSending')}
                                                    </Button>
                                                )}

                                            {!['cancelled', 'paused', 'complete'].includes(distributeStore.scheduleStatus)
                                                && (
                                                    <Button cssClass="regular primary email-builder-modal-edit-button" onClick={distributeStore.pauseSending}>
                                                        <i className="fal fa-circle-pause" />

                                                        {i18n.t('distributionEmailBuilderModal.pauseSending')}
                                                    </Button>
                                                )}
                                        </div>
                                    )}
                            </div>
                        )}

                    {distributeStore.scheduleId === 0 && (
                        <Select
                            style={{ flex: 1 }}
                            label={i18n.t('sch_email_template_label')}
                            options={distributeStore.emailTemplates}
                            value={distributeStore.selectedTemplate}
                            onBlur={distributeStore.changeTemplate}
                        />
                    )}

                    <Input
                        label={i18n.t('sch_email_subject')}
                        placeholder={i18n.t('form.input.placeholder')}
                        onChange={distributeStore.changeEmailSubject}
                        value={distributeStore.emailSubject}
                        disabled={distributeStore.readOnly}
                    />

                    {distributeStore.disableEmailSender && !distributeStore.readOnly
                        ? (
                            <div style={{ position: 'relative' }}>
                                <Typography
                                    type="b"
                                    cssClass="email-builder-modal-false-input-title"
                                >
                                    {i18n.t('sch_email_send_from_label')}
                                </Typography>

                                <div className="email-builder-modal-false-input">
                                    <p>{distributeStore.emailSender}</p>

                                    <i className="fal fa-edit" onClick={distributeStore.enableEmailSender} />
                                </div>
                            </div>
                        )
                        : (
                            <Input
                                label={i18n.t('sch_email_send_from_label')}
                                defaultValue={distributeStore.emailSender}
                                onBlur={distributeStore.changeEmailSender}
                                disabled={distributeStore.readOnly}
                            />
                        )}

                    {!distributeStore.readOnly
                        && (
                            <div className="kiosk-settings-modal-checkbox-option">
                                <Typography type="b">
                                    {i18n.t('sch_email_addReplyTo')}
                                </Typography>

                                <Checkbox
                                    onBlur={distributeStore.toggleAddReplyTo}
                                    checked={distributeStore.addReplyTo}
                                    disabled={distributeStore.readOnly}
                                />
                            </div>
                        )}

                    {distributeStore.addReplyTo
                        ? (
                            <Input
                                label={i18n.t('sch_email_replyTo')}
                                placeholder={i18n.t('form.input.placeholder')}
                                onBlur={distributeStore.changeEmailReplyTo}
                                defaultValue={distributeStore.emailReplyTo}
                                disabled={distributeStore.readOnly}
                            />
                        )
                        : null}

                    {distributeStore.readOnly && distributeStore.banner && <p style={{ fontWeight: 'bold' }}>{i18n.t('distributionEmailBuilderModal.readOnlyBannerTitle')}</p>}

                    {!distributeStore.readOnly
                        && (
                            <div>
                                <Typography type="b">
                                    {i18n.t('distributionEmailBuilderModal.bannerTitle')}
                                </Typography>

                                {!distributeStore.readOnly
                                    && (
                                        <Typography type="tiny">
                                            {i18n.t('distributionEmailBuilderModal.bannerExplainer')}
                                        </Typography>
                                    )}
                            </div>
                        )}

                    {distributeStore.banner
                        ? [
                            <div style={{
                                height: '150px',
                                textAlign: 'center',
                            }}
                            >
                                <img
                                    style={{
                                        height: '100%',
                                    }}
                                    src={`${this.props.store.http.cdnUrl}/images/survey/${distributeStore.banner}?version=${new Date().getTime()}`}
                                    width="100%"
                                />
                            </div>,
                            !distributeStore.readOnly
                                && (
                                    <Button
                                        style={{ gap: 10 }}
                                        cssClass="regular tertiary"
                                        onClick={distributeStore.removeBanner}
                                    >
                                        {i18n.t('banner.remove')}
                                        <i className="fas fa-minus-circle" />

                                    </Button>
                                ),
                        ]
                        : (
                            <div
                                className="email-builder-drag-and-drop"
                                onClick={distributeStore.selectUploadFile}
                                onDragEnter={distributeStore.handleDrag}
                            >
                                <input
                                    type="file"
                                    style={{ display: 'none' }}
                                    accept="image/png, image/jpeg, image/gif"
                                    onChange={distributeStore.upload}
                                    ref={(input) => { distributeStore.bannerInput = input }}
                                />

                                <i className="fal fa-circle-plus" />

                                <p>{i18n.t('distributionEmailBuilderModal.dragDropTitle')}</p>

                                <p style={{ fontSize: 12 }}>{i18n.t('distributionEmailBuilderModal.dragDropExplainer')}</p>

                                {distributeStore.dragActive
                                    ? (
                                        <div
                                            className="email-builder-file-element"
                                            onDragEnter={distributeStore.handleDrag}
                                            onDragLeave={distributeStore.handleDrag}
                                            onDragOver={distributeStore.handleDrag}
                                            onDrop={distributeStore.handleDragEnd}
                                        />
                                    )
                                    : null}
                            </div>
                        )}

                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                        <Typography type="b">
                            {i18n.t(distributeStore.readOnly ? 'distributionEmailBuilderModal.readOnlyEmailBody' : 'distributionEmailBuilderModal.enterMessage')}
                        </Typography>

                        <br />

                        <CKeditor5
                            data={distributeStore.emailBody}
                            onBlur={distributeStore.changeEmailBody}
                            disabled={distributeStore.readOnly}
                            toolbar="emailSchedule"
                            id={distributeStore.scheduleId}
                            store={store}
                            onSourceToggle={distributeStore.editorSourceToggle}
                        />
                    </div>

                    {!distributeStore.readOnly && distributeStore.showSetAsTemplate
                        && (
                            <div className="kiosk-settings-modal-checkbox-option">
                                <p>{i18n.t('distributionEmailBuilderModal.emailTemplate')}</p>

                                <Checkbox
                                    onBlur={distributeStore.toggleEmailTemplate}
                                    defaultChecked={distributeStore.saveAsTemplate}
                                />
                            </div>
                        )}
                </div>

                <ModalFooter>
                    <div className="email-builder-modal-footer-buttons">
                        {distributeStore.readOnly
                            ? (
                                <Button cssClass="regular tertiary" onClick={distributeStore.closeCreateEmailModal}>
                                    {i18n.t('close')}
                                </Button>
                            )
                            : (
                                <React.Fragment>
                                    <Button cssClass="regular tertiary" onClick={distributeStore.closeCreateEmailModal}>
                                        {i18n.t('cancel')}
                                    </Button>

                                    <div style={{ display: 'flex', gap: 8 }}>
                                        <Button
                                            cssClass="regular tertiary"
                                            onClick={distributeStore.showTestEmailModal}
                                            label={i18n.t('distributionEmailBuilderModal.sendTestEmail')}
                                            icon="far fa-paper-plane-top"
                                            disabled={!distributeStore.emailBody.length || !distributeStore.emailSubject.length || !distributeStore.emailSender.length}
                                        />

                                        {showScheduleButtons && (
                                            <Button
                                                cssClass="regular tertiary"
                                                label={i18n.t('sch_search_form_label_schedule')}
                                                icon="far fa-calendar-check"
                                                onClick={distributeStore.goToScheduleModal}
                                                disabled={!distributeStore.emailBody.length || !distributeStore.emailSubject.length || !distributeStore.emailSender.length}
                                            />
                                        )}

                                        <Button
                                            label={i18n.t('save')}
                                            icon="far fa-floppy-disk"
                                            cssClass="regular primary"
                                            onClick={distributeStore.saveSchedule}
                                            disabled={distributeStore.isEditingSource}
                                        />
                                    </div>
                                </React.Fragment>
                            )}
                    </div>
                </ModalFooter>
            </Modal>
        )
    }
}

export default CreateEmailModal
